var _circle, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUserPermissions = function SvgIconUserPermissions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.7,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-no-fill": "true",
    cx: 12,
    cy: 6,
    r: 4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    "data-no-fill": "true",
    cx: 12,
    cy: 17,
    rx: 7,
    ry: 4
  })));
};
export { SvgIconUserPermissions as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIxLjciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogICAgPGNpcmNsZSBkYXRhLW5vLWZpbGw9InRydWUiIGN4PSIxMiIgY3k9IjYiIHI9IjQiLz4NCiAgICA8ZWxsaXBzZSBkYXRhLW5vLWZpbGw9InRydWUiIGN4PSIxMiIgY3k9IjE3IiByeD0iNyIgcnk9IjQiLz4NCjwvc3ZnPg==";